import { render, staticRenderFns } from "./PatientDataModal.vue?vue&type=template&id=4da52356&scoped=true&"
import script from "./PatientDataModal.vue?vue&type=script&lang=js&"
export * from "./PatientDataModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientDataModal.vue?vue&type=style&index=0&id=4da52356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da52356",
  null
  
)

export default component.exports